import { useMemo } from 'react'

import type { Ticket } from '@server/models/ticket/ticket.dto'
import { TicketContext } from '@web/components/tickets/ticket/context'
import { SyncService } from '@web/services/store/sync'
import { TicketStore } from '@web/services/store/ticket.store'

interface ThreadShellProps {
  children: React.ReactNode
  ticket?: Pick<
    Ticket,
    'id' | 'remoteId' | 'title' | 'csatScore' | 'csatDidThatHelp'
  >
}

export const ThreadShell = ({ children, ticket }: ThreadShellProps) => {
  const store = useMemo(() => {
    if (!ticket) {
      return null
    }

    return new TicketStore(ticket, new SyncService(), false)
  }, [ticket])

  return (
    <TicketContext.Provider value={store}>
      <div className="flex h-full flex-1 flex-col justify-between">
        {children}
      </div>
    </TicketContext.Provider>
  )
}
